import React from 'react';
import NoData from '../../../components/fragments/IllustrationState/NoData';
import { ERROR_STATE } from '../../../constants/defaultValues/errorState';
import { Grid } from '@mantine/core';
import CardRedeem from '../../../components/card_redeem';

const WaitingApprovalList = ({ data, activeTab }) => {
  if (activeTab !== 'waiting-voucher') return null;

  if (data.length === 0) {
    return <NoData title={ERROR_STATE.empty[0]} w={200} />;
  }

  return (
    <Grid>
      {data.map((voucher, index) => (
        <CardRedeem key={index} item={voucher} jenis={'waiting'} />
      ))}
    </Grid>
  );
};

export default WaitingApprovalList;
